<template>
    <div>
        <b-modal
        id="matterTakeDownRequestFormModal"
        ref="matterTakeDownRequestFormModal"
        centered
        size="lg"
        no-close-on-backdrop
        :title="$t('matter.matter_takedown_request')"
        :cancel-title="$t('others.cancel_title')"
        :ok-title="$t('others.ok_title')"
        cancel-variant="outline-secondary"
        @ok.prevent="addorUpdate()"
      >
        <b-card>
            <b-row>
                 <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTakeDownRequest.product_category') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="productCategorySelect" value-field="id" text-field="name" :options="productCategoryOption" />
                        </b-form-group>
                   </b-form>
                </b-col>
                <b-col class="col-lg-4">
                     <b-form>
                        <label>{{ $t('matterTakeDownRequest.infringement_type') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="infringementTypeSelect" value-field="id" text-field="name" :options="infringementTypeOption" />
                        </b-form-group>
                   </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                     <b-form>
                        <label>{{ $t('matterTakeDownRequest.platform') }}</label>
                        <b-form-group>
                            <b-form-select size="sm" v-model="platformSelect" value-field="id" text-field="name" :options="platformOption" />
                        </b-form-group>
                   </b-form>
                </b-col>
            </b-row>
            <b-row>
                 <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTakeDownRequest.seller') }}</label>
                       <b-form-group>
                            <b-form-select size="sm" v-model="sellerSelect" value-field="id" text-field="name" :options="sellerOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTakeDownRequest.process_result') }}</label>
                       <b-form-group>
                            <b-form-select size="sm" v-model="processResultSelect" value-field="id" text-field="name" :options="processResultOption" />
                        </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                        <b-form>
                            <label>{{ $t('matterTakeDownRequest.trademark') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="matter-evidence-detection-case-number-input" v-model="tradeMarkName" maxlength="100" />
                            </b-form-group>
                        </b-form>
                    </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                        <b-form>
                            <label>{{ $t('matterTakeDownRequest.product') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="matter-evidence-detection-case-number-input" v-model="productName" maxlength="100" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                <b-col class="col-lg-6">
                        <b-form>
                            <label>{{ $t('matterTakeDownRequest.finding_item') }}</label>
                            <b-form-group>
                                <b-form-input size="sm" id="matter-evidence-detection-case-number-input" v-model="findingItem" maxlength="100" />
                            </b-form-group>
                        </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTakeDownRequest.service_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="serviceDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTakeDownRequest.platform_response_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="platformResponseDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                    <b-form>
                        <label>{{ $t('matterTakeDownRequest.follow_up_date') }}</label>
                        <b-form-group>
                            <b-form-datepicker today-button :label-today-button="$t('dateTime.today')"  size="sm" v-model="followUpDate" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                 <b-col class="col-lg-4">
                    <label>{{ $t('matterTakeDownRequest.is_seller_objection') }}</label>
                    <b-form-checkbox class="custom-control-success" v-model="isSellerObjection" switch>
                        <span class="switch-icon-left">
                            <feather-icon icon="CheckIcon" />
                        </span>
                        <span class="switch-icon-right">
                            <feather-icon icon="XIcon" />
                        </span>
                    </b-form-checkbox>
                </b-col>
                <b-col class="col-lg-4">
                    <label>{{ $t('matterTakeDownRequest.is_pursued') }}</label>
                    <b-form-checkbox class="custom-control-success" v-model="isPursued" switch>
                        <span class="switch-icon-left">
                            <feather-icon icon="CheckIcon" />
                        </span>
                        <span class="switch-icon-right">
                            <feather-icon icon="XIcon" />
                        </span>
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-card>
        </b-modal>
    </div>
</template>

<script>

export default{
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            productCategoryOption: [],
            productCategorySelect: 0,
            infringementTypeOption: [],
            infringementTypeSelect: 0,
            platformOption: [],
            platformSelect: 0,
            sellerOption: [],
            sellerSelect: 0,
            processResultOption: [],
            processResultSelect: 0,
            tradeMarkName: '',
            productName: '',
            findingItem: '',

            serviceDate: null,
            platformResponseDate: null,
            followUpDate: null,

            isSellerObjection: false,
            isPursued: false,
        }
    },
    methods:{
        async showTakeDownRequest(id, lawMatterId) {
            this.$refs['matterTakeDownRequestFormModal'].show()
            this.id = id
            this.lawMatterId = lawMatterId

            const data = {id: this.id }
            const controller = {name: 'LawMatterTakeDownRequest' }
            const payload = {data: data,controller: controller}
            const response = await this.$store.dispatch('moduleAuth/getInfo', payload);
            if (response.data.resultStatus == true){

                this.productCategoryOption = response.data.lawProductCategoryList
                this.productCategoryOption.splice(0, 0, this.$nullSelected())
                this.productCategorySelect = response.data.lawMatterTakeDownRequest.lawProductCategoryId

                this.infringementTypeOption = response.data.lawInfringementTypeList
                this.infringementTypeOption.splice(0, 0, this.$nullSelected())
                this.infringementTypeSelect = response.data.lawMatterTakeDownRequest.lawInfringementTypeId

                this.platformOption = response.data.lawCounterPartyPlatformList
                this.platformOption.splice(0, 0, this.$nullSelected())
                this.platformSelect = response.data.lawMatterTakeDownRequest.lawCounterPartyPlatformId

                this.sellerOption = response.data.lawCounterPartySellerList
                this.sellerOption.splice(0, 0, this.$nullSelected())
                this.sellerSelect = response.data.lawMatterTakeDownRequest.lawCounterPartySellerId

                this.processResultOption = response.data.lawMatterProcessResultList
                this.processResultOption.splice(0, 0, this.$nullSelected())
                this.processResultSelect = response.data.lawMatterTakeDownRequest.lawMatterProcessResultId


                this.tradeMarkName = response.data.lawMatterTakeDownRequest.trademarkName
                this.productName = response.data.lawMatterTakeDownRequest.productName
                this.findingItem = response.data.lawMatterTakeDownRequest.findingItem

                this.serviceDate = response.data.lawMatterTakeDownRequest.serviceDate
                this.platformResponseDate = response.data.lawMatterTakeDownRequest.platformResponseDate
                this.followUpDate = response.data.lawMatterTakeDownRequest.followUpDate

                this.isSellerObjection = response.data.lawMatterTakeDownRequest.isSellerObjection
                this.isPursued = response.data.lawMatterTakeDownRequest.isPursued                

            }else{
                this.$bvModal.hide('matterTakeDownRequestFormModal')
                    this.$WarningAlert(response.data.resultMessage)
            }
        },
        async addorUpdate(){

            const matterTakeDownRequestData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            lawProductCategoryId :this.productCategorySelect,
                            lawInfringementTypeId: this.infringementTypeSelect,
                            lawCounterPartyPlatformId: this.platformSelect,
                            lawCounterPartySellerId: this.sellerSelect,
                            lawMatterProcessResultId: this.processResultSelect,
                            trademarkName: this.tradeMarkName,
                            productName: this.productName,
                            findingItem: this.findingItem,
                            serviceDate: this.serviceDate,
                            platformResponseDate :this.platformResponseDate,
                            followUpDate: this.followUpDate,
                            isSellerObjection :this.isSellerObjection,
                            isPursued: this.isPursued
                          
                        }
            const controller = {
                name: 'LawMatterTakeDownRequest'
            }
            const payload = {
                data: matterTakeDownRequestData,
                controller: controller
            }
            
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if(!this.id){
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(13, this.id, this.lawMatterId,this.employeeId)
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterTakeDownRequestFormModal')
                this.$SaveAlert()
            } else {
                    this.$WarningAlert(response.data.resultMessage)
              }
           
        }
    }

    }

</script>